/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationPolicyWizard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const CertificationPolicyWizardTestIds = {
  btnNextStep: "btn-next-step",
  btnPreviousStep: "btn-previous-step",
  btnSaveAndReturn: "btn-save-and-return",
  certificationPolicyWizardPage: "certification-policy-wizard-page",
  certificationPolicyWizardStepContainer: "certification-policy-wizard-step-container",
  wizardDefaultPolicyInfo: "wizard-default-policy-info",
  wizardForbidden: "wizard-forbidden"
} as const;
